module.exports = __webpack_public_path__ + "fonts/76b143ae80fdc86de4f1b964f4259e31.svg";